import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'rmwc/Button'
import { Grid, GridCell } from 'rmwc/Grid'
import { TextField } from 'rmwc/TextField'
import { Card } from 'rmwc/Card'
import { Typography } from 'rmwc/Typography'
import { ListDivider } from 'rmwc/List'
import * as api from '../../api/api'
import ReactExport from "react-data-export";
import StatusMessage from '../../util/StatusMessage'
import SearchComponent from '../SearchComponent';


class AdminTqReportDetails extends Component {
	constructor(props){
		super(props)
		this.state = {
			errorMsg: '',
			downloadDisable: true,
			reportDownloadDisable: false,
      searchErrorMsg: '',
      searchStatus: false,
			data:{
				page: 1,
				totalPages: '',
				uploadDataList: [],
				exportData: [],
				startId: 1,
				reportId: '',
        userId: '',
			},
		}
	}

	componentDidMount(){
		let type = 'list'
    this.fetchDetails('',type)
  }

  fetchDetails = (e, type) => {
    let data = Object.assign({}, this.state.data)
    let pageNo = this.state.data.page
    let startId = this.state.data.startId
    api.fetchTqReportScoreUploadDetails(this.props.user.accessToken, type, pageNo, startId)
    .then((result) => {
    	if(type === 'list'){
	      if (result.status === 'error') {
	        this.setState({ errorMsg: result.message })  
	      }
	      else if (result.status === 'success') {
	        data.uploadDataList = result.data
	        data.totalPages = result.page_count
	        this.setState({data:data})
	      }
	    }
	    else if (type === 'export') {
	    	if (result.status === 'error') {
	        this.setState({ errorMsg: result.message })  
	      }
	      else if (result.status === 'success') {
	        data.exportData = result.data
	        this.setState({data:data, downloadDisable: false})
	      }
	    }
	  })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  }

  onInputChange = evt => {
    let data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data:data});
  }

  handleFetch = (e, type) => {
    e.preventDefault()
    if(!this.state.searchStatus){
      this.fetchDetails(e, type)
    }
    else{
      this.handleUserSearch()
    }
  }

  handleBack = (e) => {
  	e.preventDefault()
  	this.props.history.push('/portal/app/admin/tq/reports/home')
  }

  handleClear = (e) => {
    let data = Object.assign({}, this.state.data);
    data.page = 1
    data.uploadDataList = ''
    data.totalPages = ''
    data.userId = ''
    this.setState({data:data, searchErrorMsg: '', searchStatus: false})
  }

  fetchSpecificReport = (e) => {
  	e.preventDefault()
    let report_id = this.state.data.reportId
    this.setState({reportDownloadDisable: true})
    api.downloadAdminTPOReport(this.props.user.accessToken, this.state.data.reportId)
    .then((result) => {
       if (result instanceof Blob){
        this.setState({ errorMsg: '', reportDownloadDisable: false })
        const url = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${report_id}_report.pdf`);
        document.body.appendChild(link);
        link.click();
      }
      else{
        this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to download reports. Please contact Administrator' })
      }      
    }).catch((err) => {
        this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to downlod reports. Please contact Admin' })
    })
	}

  handleUserSearch = () => {
      let data = Object.assign({}, this.state.data)
      let pageNo
      if (!this.state.searchStatus){
        pageNo = 1
      }
      else{
        pageNo = data.page
      }

      let url = `fetch/details/tq_score/report/user/search/${data.userId}/${pageNo}`
      api.getResponse(this.props.user.accessToken, url).then((result) => {
        const { status, errors} = result
        if(status == 'error'){
          this.setState({searchErrorMsg: result.message})
        }
        else if (status == 'success'){
          data.uploadDataList = result.data
          data.totalPages = result.count
          this.setState({data:data, searchErrorMsg: '', searchStatus: true})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details' })
      })
    }


  render(){
  	let detailsListComponent, detailsexportComponent, pageNumberChangeComponent;
  	let ExcelFile = ReactExport.ExcelFile;
    let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    let ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    
    detailsexportComponent = (
    	<GridCell span="12">
    		<TextField className= "text_input" label= "Start Id" name= "startId" onChange={this.onInputChange} value={this.state.data.startId}></TextField>
    		<Button dense onClick= {(e) => {this.handleFetch(e, 'export')}}>Export</Button>
    		<ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
    			<ExcelSheet data={this.state.data.exportData} name="UserDetailsAndSectionScores">
    				<ExcelColumn label="Report Id" value="report_id"/>
    				<ExcelColumn label="User Id" value="user_id"/>
    				<ExcelColumn label="First Name" value="first_name"/>
    				<ExcelColumn label="Last Name" value="last_name"/>
    				<ExcelColumn label="Test Track" value="tq_test_track"/>
    				<ExcelColumn label="Set No" value="set_no"/>
    				<ExcelColumn label="Score" value="total_score"/>
    				<ExcelColumn label="Subject Expertise" value="subject_expertise"/>
    				<ExcelColumn label="Understanding of Pedagogical Practices" value="understanding_of_pedagogical_practices"/>
    				<ExcelColumn label="Communication" value="communication"/>
    				<ExcelColumn label="Pedagogical Understanding in Online Teaching" value="pedagogical_understanding_in_online_teaching"/>
    				<ExcelColumn label="Number of Themes Available" value="available_themes_count"/>
            <ExcelColumn label="Date of Issue" value="created_at"/>
            <ExcelColumn label="Report download count" value="report_download_count"/>
    			</ExcelSheet>
    		</ExcelFile>
    	</GridCell>
    	)

  	if(this.state.data.uploadDataList.length > 0){
  		detailsListComponent = (
  			<tbody>
  				{this.state.data.uploadDataList.map(function(list){
  					return(<tr>
  						<td>{list.report_id}</td>
  						<td>{list.user_id}</td>
  						<td>{list.tq_id}</td>
  						<td>{list.first_name}</td>
  						<td>{list.last_name}</td>
  						<td>{list.tq_test_track}</td>
  						<td>{list.set_no}</td>
  						<td>{list.total_score}</td>
  						<td>{list.subject_expertise}</td>
  						<td>{list.understanding_of_pedagogical_practices}</td>
  						<td>{list.communication}</td>
  						<td>{list.pedagogical_understanding_in_online_teaching}</td>
              <td>{list.available_themes_count}</td>
              <td>{list.created_at}</td>
              <td>{list.report_download_count}</td>
  						</tr>)
  				})}
  			</tbody>
  		)
  	}

    if(this.state.searchStatus){
      pageNumberChangeComponent = (
        <GridCell span= "6">
          <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onInputChange} value={this.state.data.page}/>
          <Button onClick={(e) => {this.handleFetch(e, 'search')}}>Fetch</Button>
          <Button onClick={(e) => {this.handleClear(e)}}>Clear</Button>
        </GridCell>
      ) 
    }
    else {
      pageNumberChangeComponent = (
        <GridCell span= "6">
          <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onInputChange} value={this.state.data.page}/>
          <Button onClick={(e) => {this.handleFetch(e, 'list')}}>Fetch</Button>
          <Button onClick={(e) => {this.handleClear(e)}}>Clear</Button>
        </GridCell>
      ) 
    }

  	return(
  		<div>
  			<Card style={{padding: '20px'}}>
          <Grid>
            <GridCell span="11"  style={{textAlign: "center"}}>
              <Typography use="headline5">TQ Report Details</Typography>
            </GridCell>
            <GridCell span="1">
        			<Button raised onClick = {((e) => this.handleBack(e))}>Back</Button>
        		</GridCell>
          </Grid>
        </Card>
        	<Grid>
        		<GridCell span="6">
        		{detailsexportComponent}
        		<Typography use="caption">Note: 500 records per export</Typography>
        		</GridCell>

        		<GridCell span="6">
        			<TextField  className='text_input' type="number" label="Report Id" autoComplete="off" name="reportId" onChange={this.onInputChange} value={this.state.data.reportId}/>
            	&nbsp;
            	<Button  onClick={((e) => this.fetchSpecificReport(e))} disabled={this.state.reportDownloadDisable}>Download</Button>
            	<br/>
            	<Typography use="caption">Download specific report</Typography>
            </GridCell>

            <GridCell span="12">
            	<ListDivider/>
            </GridCell>

            <GridCell span="11" style={{textAlign: "center"}}>
              <Typography use="headline6" style={{textDecoration: "underline"}}>TQ Report Scores List</Typography>
            </GridCell>

        		<GridCell span= "12">
	        		Total Pages - {this.state.data.totalPages}
	        	</GridCell>

            {pageNumberChangeComponent}

            <GridCell span="6">
              <TextField  className='text_input' type="number" label="User Id Search" autoComplete="off" name="userId" onChange={this.onInputChange} value={this.state.data.userId}/>
              &nbsp;
              <Button  onClick={((e) => this.handleUserSearch(e))}>Search</Button>
              <Button  onClick={((e) => this.handleClear(e))}>Clear</Button>
              <StatusMessage error_msg = {this.state.searchErrorMsg}/>
            </GridCell>

	        	<GridCell span="12">
            	<StatusMessage error_msg = {this.state.errorMsg}/>
        		</GridCell>

	        	<GridCell span="12">
				        <table>
				          <th>Report Id</th>
				          <th>User Id</th>
				          <th>TQ Id</th>
				          <th>First Name</th>
				          <th>Last Name</th>
				          <th>Test Track</th>
				          <th>Set No</th>
				          <th>Score</th>
				          <th>Subject Expertise</th>
				          <th>Understanding of Pedagogical Practices</th>
				          <th>Communication</th>
				          <th>Pedagogical Understanding in Online Teaching</th>
                  <th>Number of Themes Available</th>
                  <th>Date Of Issue</th>
                  <th>Report Download Count</th>
				          {detailsListComponent}
				        </table>
				    </GridCell>
        	</Grid>
        </div>
  	)
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTqReportDetails);


// WEBPACK FOOTER //
// ./src/views/admin/AdminTqReportDetails.jsx